module.exports = __webpack_public_path__ + "static/img/planet6.a64d15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planet6.png
// module id = zJa7
// module chunks = 1